import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "nav-item nav-entry nav-entry__account"
};
const _hoisted_2 = {
    class: "caption d-none d-md-flex",
    style: { "padding-left": "20px" }
};
const _hoisted_3 = { class: "text-muted" };
const _hoisted_4 = { class: "text" };
const _hoisted_5 = { class: "icon-container cursor-pointer" };
const _hoisted_6 = ["title"];
const _hoisted_7 = { class: "content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_ctx.accountDisplayName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
                class: "d-flex",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.onShowAccount && _ctx.onShowAccount(...args)), ["stop", "prevent"]))
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$tc('client.Identity.Accounts.Current')), 1),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.accountDisplayName), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                        class: "icon",
                        title: _ctx.$tc('client.Identity.Accounts.Current') + ': ' + _ctx.accountDisplayName
                    }, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_g_icon, {
                                width: "16",
                                height: "16",
                                src: "/assets/icons/building.svg",
                                style: { "margin-bottom": "2px" }
                            })
                        ])
                    ], 8, _hoisted_6)
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
